// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
#subtitle-2 #images-count-title,
#subtitle-2 #images-count-add {
  width: 50%;
  color: var(--ion-text-color);
}
#subtitle-2 #images-count-title {
  font-size: 17px;
  font-weight: 700;
}
#subtitle-2 #images-count-add {
  text-align: right;
}
#subtitle-2 #images-count-add ion-button {
  margin: 0px;
  text-transform: capitalize;
  --padding-start: 0px;
  --padding-end: 24px;
  font-size: 13px;
  font-weight: 500;
}
#subtitle-2 #images-count-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

ion-list {
  background: transparent;
}
ion-list .gallery-item {
  --background: transparent;
  --padding-start: 16px;
  --padding-end: 16px;
}
ion-list ion-card {
  margin: 0;
  margin-bottom: 2px;
  min-height: 180px;
  width: 100%;
  border-radius: 8px;
  z-index: 1;
}
ion-list ion-card ion-card-content div {
  margin-top: 32px;
  margin-bottom: 48px;
  max-height: 180px;
  font-size: 14px;
  font-weight: 500;
}
ion-list ion-card ion-card-content div.image {
  width: 100%;
  height: 180px;
  margin: 0;
  padding: 8px;
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  text-align: right;
}
ion-list ion-card ion-card-content div p {
  margin-top: 16px;
  margin-bottom: 16px;
}
ion-list .simple-header {
  font-size: 14px;
  font-weight: 500;
}
ion-list .simple-header ion-label {
  margin-top: 0;
}

.error-label {
  color: var(--ion-color-danger);
}

.error-feedback-wrapper {
  min-height: 18px;
  margin-top: 16px;
}
.error-feedback-wrapper .error-feedback {
  text-align: center;
}

.remove-image-icon {
  margin: 0;
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 2px black;
  border-radius: 50%;
  color: black;
  width: 24px;
  height: 24px;
}

ion-card-content {
  padding: 10px 0px;
}

.section-logo {
  margin-bottom: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  margin-left: 3px;
  margin-right: 3px;
}
.section-logo .container-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
}
.section-logo .container-image ion-icon {
  position: absolute;
  bottom: -4px;
  right: -5px;
  background: var(--ion-color-primary);
  color: #ffffff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
}
.section-logo .container-image div {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  padding: 5px;
  background-size: cover;
}
.section-logo .default-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
}
.section-logo .default-image div img {
  width: 142px;
  height: 132px;
  border-radius: 50%;
  border: none;
}

.custom-category-form .custom-item-form {
  margin-bottom: 24px;
  border: 2px solid #ede9e9;
}
.custom-category-form .c-textarea {
  min-height: 56px;
  height: auto;
}
.custom-category-form .custom-item-form ::ng-deep .required-indicator .label-text::after {
  content: "*";
  transform: translate(-100%, 0);
  color: red !important;
  padding-left: 5px;
}
.custom-category-form .custom-item-form ::ng-deep .custom-input .label-text {
  color: #0D253A !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.custom-category-form .custom-item-form ::ng-deep .custom-input {
  color: #0D253A !important;
  font-family: "Poppins";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/store-core/lib/components/subcategory-form/subcategory-form.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;;EAEE,UAAA;EACA,4BAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAGI;EACE,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AADN;AAGM;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AADR;;AAOA;EACE,uBAAA;AAJF;AAME;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AALJ;AAQM;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EAmBA,eAAA;EACA,gBAAA;AAxBR;AAMQ;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,iBAAA;AAJV;AAQQ;EACE,gBAAA;EACA,mBAAA;AANV;AAeE;EACE,eAAA;EACA,gBAAA;AAbJ;AAeI;EACE,aAAA;AAbN;;AAkBA;EACE,8BAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,gBAAA;AAfF;AAiBE;EACE,kBAAA;AAfJ;;AAmBA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,iBAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAhBF;AAkBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAhBJ;AAkBI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAhBN;AAmBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AAjBN;AAqBE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;AAnBJ;AAsBM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AApBR;;AA4BE;EACE,mBAAA;EACA,yBAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,YAAA;AA1BJ;AA8BI;EACE,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AA5BN;AA+BI;EACE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AA7BN;AAgCI;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA9BN","sourcesContent":["#subtitle-2 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  #images-count-title,\n  #images-count-add {\n    width: 50%;\n    color: var(--ion-text-color);\n  }\n\n  #images-count-title {\n    font-size: 17px;\n    font-weight: 700;\n  }\n\n  #images-count-add {\n    text-align: right;\n\n    ion-button {\n      margin: 0px;\n      text-transform: capitalize;\n      --padding-start: 0px;\n      --padding-end: 24px;\n      font-size: 13px;\n      font-weight: 500;\n\n      ion-icon {\n        margin-right: 3px;\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n}\n\nion-list {\n  background: transparent;\n\n  .gallery-item {\n    --background: transparent;\n    --padding-start: 16px;\n    --padding-end: 16px;\n  }\n\n  ion-card {\n    margin: 0;\n    margin-bottom: 2px;\n    min-height: 180px;\n    width: 100%;\n    border-radius: 8px;\n    z-index: 1;\n\n    ion-card-content {\n      div {\n        margin-top: 32px;\n        margin-bottom: 48px;\n        max-height: 180px;\n\n        &.image {\n          width: 100%;\n          height: 180px;\n          margin: 0;\n          padding: 8px;\n          background-size: contain;\n          background-position: top;\n          background-repeat: no-repeat;\n          text-align: right;\n\n        }\n\n        p {\n          margin-top: 16px;\n          margin-bottom: 16px;\n        }\n\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .simple-header {\n    font-size: 14px;\n    font-weight: 500;\n\n    ion-label {\n      margin-top: 0;\n    }\n  }\n}\n\n.error-label {\n  color: var(--ion-color-danger);\n}\n\n.error-feedback-wrapper {\n  min-height: 18px;\n  margin-top: 16px;\n\n  .error-feedback {\n    text-align: center;\n  }\n}\n\n.remove-image-icon {\n  margin: 0;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #ffffff;\n  box-shadow: 0px 0px 7px 2px black;\n  border-radius: 50%;\n  color: black;\n  width: 24px;\n  height: 24px;\n}\n\nion-card-content {\n  padding: 10px 0px;\n}\n\n.section-logo {\n  margin-bottom: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  text-align: center;\n  margin-left: 3px;\n  margin-right: 3px;\n\n  .container-image {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    position: relative;\n\n    ion-icon {\n      position: absolute;\n      bottom: -4px;\n      right: -5px;\n      background: var(--ion-color-primary);\n      color: #ffffff;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      padding: 8px;\n      cursor: pointer;\n    }\n\n    div {\n      width: 80px;\n      height: 80px;\n      border-radius: 50%;\n      padding: 5px;\n      background-size: cover;\n    }\n  }\n\n  .default-image {\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n\n    div {\n      img {\n        width: 142px;\n        height: 132px;\n        border-radius: 50%;\n        border: none;\n      }\n    }\n  }\n\n}\n\n.custom-category-form {\n  .custom-item-form {\n    margin-bottom: 24px;\n    border: 2px solid #ede9e9;\n  }\n\n  .c-textarea {\n    min-height: 56px;\n    height: auto;\n  }\n\n  .custom-item-form {\n    ::ng-deep .required-indicator .label-text::after {\n      content: '*';\n      transform: translate(-100%, 0);\n      color: red !important;\n      padding-left: 5px;\n    }\n\n    ::ng-deep .custom-input .label-text {\n      color: #0D253A !important;\n      font-feature-settings: \"liga\" off, \"clig\" off;\n      font-family: \"Roboto\";\n      font-size: 16px !important;\n    }\n\n    ::ng-deep .custom-input {\n      color: #0D253A !important;\n      font-family: \"Poppins\";\n      font-size: 16px !important;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      margin-bottom: 0px;\n      bottom: 2px;\n    }\n\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
